// extracted by mini-css-extract-plugin
module.exports = {"PaginationBox":"CarriersPagination_PaginationBox__uhUUh"};